module.exports = __webpack_public_path__ + "img/thumbnail_AfricanSpurredTortoise_j_normal.f9081477.png";